import { observer } from "mobx-react-lite";
import { useCallback } from "react";
import { globalModel } from "./GlobalModel";
import type { UserInfo } from "./GlobalType";
import { IS_STANDALONE } from "../standalone/config";
import { TactikLoginModal } from "../standalone/components/TactikLoginModal";
import { LoginModal } from "../platform_spaces/home/LoginModal";

/** 全站唯一登录弹窗，任意页面可经 globalModel.openLoginModal() 打开 */
export const GlobalLoginModal = observer(() => {
  const onCancel = useCallback(() => {
    globalModel.closeLoginModal();
  }, []);

  const onLoginSuccess = useCallback((user: UserInfo) => {
    globalModel.setLoggedIn(true, user);
    globalModel.closeLoginModal();
  }, []);

  if (IS_STANDALONE) {
    return (
      <TactikLoginModal
        open={globalModel.isLoginModalVisible}
        onCancel={onCancel}
        onLoginSuccess={onLoginSuccess}
      />
    );
  }

  return (
    <LoginModal
      open={globalModel.isLoginModalVisible}
      onCancel={onCancel}
      onLoginSuccess={onLoginSuccess}
    />
  );
});
